import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { LanguageToggle } from "@/components/landing/LanguageToggle";

export const PrivacyPage = () => {
  const { t } = useLang();
  const p = t.privacy;

  useEffect(() => {
    document.getElementById("emergent-badge")?.remove();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen">
      <div className="noise" />
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-24">
        <div className="flex items-center justify-between mb-10">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-muted hover:text-white transition-colors" data-testid="privacy-back">
            <ArrowLeft size={16} /> {p.back}
          </a>
          <LanguageToggle />
        </div>

        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-white" data-testid="privacy-title">{p.title}</h1>
        <p className="mt-2 font-mono text-xs text-[var(--muted-2)]">{p.updated}</p>

        <div className="mt-10 space-y-8">
          {p.sections.map((s, i) => (
            <div key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display text-lg font-semibold text-white">{s.h}</h2>
              <p className="mt-2 text-sm text-white/90 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
